module.exports = __webpack_public_path__ + "static/media/telecoms.5240c220.svg";